import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import Error from "../Error/Error";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./Token.css";
require("dotenv").config();
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_CLIENT_KEY);
 
class Token extends React.Component
{
  constructor(props) {
    super(props);
  
    const isLoggedIn = window.localStorage.getItem("userid") ? true : false;
    let userid = 0;
    if(isLoggedIn)
    {
    userid = window.localStorage.getItem("userid");

    }

    this.state = {
      price: 0,
      stage: 0,
      userid: userid,
      message : ''
    };
  }



  componentDidMount() {

  }

     handleClick = async (event) => {
      event.preventDefault();
      this.setState({stage: 0})
      this.setState({message: ''})

      if(this.state.price == 0)
      {
        return;
      }

        let data = {
            price : parseInt(this.state.price),
            qty : 1,
            userid: this.state.userid
        }
   
          // Get Stripe.js instance
          const stripe = await stripePromise;
      
          // Call your backend to create the Checkout Session
          
          const response = await fetch(process.env.REACT_APP_COMPANY_API + 'api/transaction', { method: 'POST', 
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)});
          
      
          const session = await response.json();
      
          // When the customer clicks on the button, redirect them to Checkout.
          const result = await stripe.redirectToCheckout({
            sessionId: session.id,
          });
      
          if (result.error) {
            // If `redirectToCheckout` fails due to a browser or network
            // error, display the localized error message to your customer
            // using `result.error.message`.
            this.setState({stage: 3})
            this.setState({message: result.error.message})
          }
     
    
       
      };

      onTokenChange = (event) => {
        event.preventDefault();
        this.setState({price: event.target.value})
      }

      validateForm = () => {
        return this.state.price  > 0;
      }

      render(){
        return (
       <div className="row col-md-3 token-form">
      
           {this.state.stage == 3 ? <Error Message={this.state.message + '. Please contact help desk.'}/> : ''}

             
         <Form onSubmit={this.handleClick}>
        <Form.Group size="lg" controlId="token">
          <Form.Label><b>Please select Tokens to purchase</b></Form.Label>
          <Form.Control as="select" onChange={this.onTokenChange.bind(this)}>
          <option></option>
          <option value="0"></option>
           <option value="5">$5 - 10 Tokens</option>
           <option value="10">$10 - 20 Tokens</option>
           <option value="25">$25 - 50 Tokens</option>
    </Form.Control>
    </Form.Group>
    <Button className="button" block size="lg" type="submit" disabled={!this.validateForm()}>
          Continue 
        </Button>
        </Form>
       </div>)
}
}
 
export default Token;